import { render } from "./SubaccountsList.vue?vue&type=template&id=5b1024e7&scoped=true"
import script from "./SubaccountsList.vue?vue&type=script&lang=js"
export * from "./SubaccountsList.vue?vue&type=script&lang=js"

import "./SubaccountsList.vue?vue&type=style&index=0&id=5b1024e7&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1024e7"]])

export default __exports__